// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__228N3","info":"UpdateTermsInfo_info__16mvC"};